var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.prompt))]),_c('iframe',{attrs:{"frameborder":"0","id":(_vm.frameId + "-file-frame"),"src":_vm.fileString,"height":_vm.frameHeight,"width":_vm.frameWidth}})])}
var staticRenderFns = []

export { render, staticRenderFns }